import React from 'react';
import GraduationHat from 'src/app/icons/Monospaced/GraduationHat/GraduationHat';
import CalendarDate from 'src/app/icons/Monospaced/Calendar/CalendarDate';
import UserCircle from 'src/app/icons/Monospaced/User/UserCircle';
import Settings01 from 'src/app/icons/Monospaced/Settings/Settings01';
import ArrowSquareUpRight from 'src/app/icons/Monospaced/ArrowSquare/ArrowSquareUpRight';
import { cssVar } from 'src/app/styles/helper';
import { FeaturesStack } from './ResourcesMegaMenu.styles';
import Typography from 'src/app/atoms/Typography/Typography';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import PresentationChart02 from 'src/app/icons/Monospaced/PresentationChart/PresentationChart02';
import Flag04 from 'src/app/icons/Monospaced/Flag/Flag04';
import Phone02 from 'src/app/icons/Monospaced/Phone/Phone02';
import Users01 from 'src/app/icons/Monospaced/Users/Users01';
import Announcement01 from 'src/app/icons/Monospaced/Announcement/Announcement01';
import MegaMenuLink from 'src/app/molecules/Header/MegaMenu/MegaMenuLink';

const topicLinks = [
  {
    label: 'Coaching',
    href: '/resources/coaching',
    icon: (
      <PresentationChart02
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Communities & Memberships',
    href: '/resources/communities-memberships',
    icon: (
      <Flag04
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Creators & Entrepreneurs',
    href: '/resources/creators-entrepreneurs',
    icon: (
      <UserCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Branded Apps',
    href: '/resources/branded-apps',
    icon: (
      <Phone02
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Online Courses',
    href: '/resources/online-courses',
    icon: (
      <GraduationHat
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'All Topics',
    href: '/resources',
    icon: (
      <ArrowSquareUpRight
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
];

const trainingLinks = [
  {
    label: 'Join Our Free Community',
    href: 'https://community.mightynetworks.com/events?utm_source=website&utm_medium=mega_menu&utm_campaign=mc_education&_gl=1*1v53vat*_gcl_au*OTgyODk1MTk4LjE3NDYxMTQ1NzI.*_ga*MzQyNDM3NzU2LjE3NDYxMTQ1NzI.*_ga_7M2C06HKGP*czE3NDc3NjMzNzkkbzMyJGcxJHQxNzQ3NzY1MDAxJGozNCRsMCRoMCRkbEhDYVMxZEdadUtZcG9zWkwyd0N4LU1wOUZFanR5OTlIQQ..&_ga=2.3201976.909218863.1747680084-342437756.1746114572',
    icon: (
      <Users01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Setup Guidance',
    href: 'https://community.mightynetworks.com/spaces/12898937/content',
    icon: (
      <Settings01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'New Features',
    href: 'https://community.mightynetworks.com/spaces/12890096/search?term=%23FeatureUpdates&sort=created_at&sort_order=desc',
    icon: (
      <Announcement01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Weekly Trainings',
    href: 'https://community.mightynetworks.com/events',
    icon: (
      <CalendarDate
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
];

const ResourcesMegaMenuFeatures = (): JSX.Element => {
  return (
    <FeaturesStack
      direction='column'
      align='stretch'
      justify='flex-start'
      gap={'spacing-2xl'}
      padding={['spacing-3xl', 'spacing-3xl', 'spacing-3xl', 'spacing-none']}
      paddingLg='spacing-xl'
    >
      <Stack
        direction='column'
        align='flex-start'
        justify='flex-start'
        gap={'spacing-lg'}
      >
        <Typography
          type='paragraph'
          size='sm'
          fontWeight='font-weight-semibold'
          color='text-brand-secondary'
        >
          Topics
        </Typography>
        <Grid
          totalColumns={2}
          totalColumnsLg={1}
        >
          {topicLinks.map((link) => (
            <MegaMenuLink
              key={link.label}
              {...link}
            />
          ))}
        </Grid>
      </Stack>
      <Stack
        direction='column'
        align='flex-start'
        justify='flex-start'
        gap={'spacing-lg'}
      >
        <Typography
          type='paragraph'
          size='sm'
          fontWeight='font-weight-semibold'
          color='text-brand-secondary'
        >
          Training & Guidance
        </Typography>
        <Grid
          totalColumns={2}
          totalColumnsLg={1}
        >
          {trainingLinks.map((link) => (
            <MegaMenuLink
              key={link.label}
              {...link}
            />
          ))}
        </Grid>
      </Stack>
    </FeaturesStack>
  );
};

export default ResourcesMegaMenuFeatures;
